<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="SAP ID"
                  v-model="formSchema.sap_id"
                  :rules="[v => !!v || 'Sap id is required !', lng10]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Employee Name"
                  v-model="formSchema.employee_name"
                  :rules="[v => !!v || 'Employee name is required!',lng100]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                label="Designation"
                item-text="designation_name"
                item-value="id"
                v-model="formSchema.designation_id"
                :items="designationList"
                :rules="[v => !!v || 'Designation is required !']"
                required>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Organization"
                  v-model="formSchema.organization"
                  :rules="[v => !!v || 'Organization is required !,lng10']"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>                                
                <v-autocomplete
                label="Project Designation"
                item-text="designation_name"
                item-value="id"
                v-model="formSchema.project_designation_id"
                :items="designationList"
                :rules="[v => !!v || 'Project Designation is required !']"
                required>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Mobile Number"
                  v-model="formSchema.mobile_no"
                  :rules="[phoneNum]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Office Phone"
                  v-model="formSchema.office_phone"
                  :rules="[phoneNum]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="IP Phone"
                  v-model="formSchema.ip_phone"
                  :rules="[IpPhone, lng15]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Email"
                  v-model="formSchema.email"
                  :rules="[email]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Rank"
                  v-model="formSchema.rank"
                  :items="rankList"
                  :rules="[v => !!v || 'Rank is required !']"
                  required
                ></v-autocomplete>
              </v-flex>
                  
              <v-flex xs12 sm6 md4>
                 <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'project_join_date', fieldValue:formSchema.project_join_date, label:'Join Date'}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:2,fieldName:'project_end_date', fieldValue:formSchema.project_end_date, label:'Release Date', disabled:'1'}"
                  ref="setRange"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>  

              <v-flex xs12 sm6 md4>
                <v-autocomplete            
                label="Select user for login"
                item-text="name"
                item-value="id"
                v-model="formSchema.user_id"            
                :items="userList" 
                clearable    
                ></v-autocomplete>  
              </v-flex>         

              <v-flex xs12 sm6 md4>
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="statusVal"></v-checkbox>
              </v-flex>
              
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template>
          <v-btn v-if="(userRole.saveButton || userRole.updateButton)  && viewPermission==0" color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>

          <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </template>
         
          
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

export default {
  props: ["formSchema","viewPermission"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,

    showForm: false,

    statusVal: 1,
    rankList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    designationList:[],
    userList:[],

    /*email: [
      v => !!v || "Field is required",
      v =>
        /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "Enter valied e-mail"
    ],*/

    phone: [
      v => !!v || "Field is required",
      v => /^\d+$/.test(v) || "Enter a valid phone number!"
    ]
  }),

  watch: {
    userRole: function(){}
  },

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Project Employee Information"
        : "Add Project Employee Information";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = true;//role.saveButton;      
      return role;
    }
  },

  created() {    
    /*commonService.getAllData("get-desig-dropdown-data").then(res => {*/
    commonService.getAllData("get-dropdown-data-for-emp").then(res => {
      this.userList = res.userList;
      this.designationList = res.designationList;
    });
  },

  methods: {
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;

      if(data.fieldName == "project_join_date"){
        this.formSchema.project_end_date = ""
        this.$refs.setRange.setRange(data.value);
      }

    },

    validateBeforeSubmit(e) {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {
      var formSchema = this.formSchema;
        
      formSchema.project_join_date = this.changeFormateYMD(
        formSchema.project_join_date
      );
      formSchema.project_end_date = this.changeFormateYMD(formSchema.project_end_date);

      if (formSchema.id > 0) {
        commonService
          .updateFormData(formSchema, "project-staff-info")
          .then(res => {
            this.showForm = this.userRole.saveButton;
            let actionData = {
              message: res.message,
              data: res.data,
              action: "edit",
              status: res.status
            };
            this.close(actionData);
          });
      } else {
        commonService
          .insertFormData(formSchema, "project-staff-info")
          .then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "add",
              status: res.status
            };
            this.close(actionData);
          });
      }
    },

    resetForm(){
      this.formSchema.id = 0;   
      this.viewPermission = 0      
      this.showForm = this.userRole.saveButton
    },

    close: function(data) {
      if(data.status==1)
      {
        this.$refs.form.reset();
        this.formSchema.id = 0;
        this.formSchema.project_join_date = ''
        this.formSchema.project_end_date = '';
      }      
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/project_info/project_staff_info/insertForm.vue